/**
 * created by xcc
 * 用户管理   sys
 */

import React, {Component} from "react";
import {
    Row,
    Col,
    Tree,
    Button,
    Input,
    Pagination,
    Modal,
    message,
    TreeSelect
} from "antd";
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT} from "../../constants";
import {connect} from "react-redux";
import * as Action from '../../actions/UserManagementSys';
import UserManagementSysList from "../../view/components/userManagementSys/UserManagementSys";
import AddUser from "../../view/components/userManagementSys/AddUser";
import "antd/dist/antd.css";

const {Search} = Input;
const {TreeNode} = Tree;

class userManagementSys extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: 1,
            size: 10,
            dataList: [],
            listTotal: 0,
            allChoose: false,
            searchValue: null, //搜索
            currentLeftMenuList: [],
            nodeKey: [],
            allVisible: false,
            renameVisible: false,
            delVisible: false,
            currentUser: "",
            userStatus: 1,
            userVisible: false,
            roleData: [],
            addUserProps: {
                accountValue: "",
                nameValue: "",
                officePhoneValue: "",
                sexValue: "",
                phoneValue: "",
                allDept: [],
                checkedKeys: "",
                propertyValue: "",
                typeKey: [],
                allRole: [],
                mediaRoleCodes: [],
                mediaRoles: "",
                mediaCodes: [],
                roleCodes: [],
                allMedia: []
            },
            id: "",
            deptTreeData: [],
            deptKey: "",
            roleKey: "",
            roleNewData: [],
            deptNewData: [],
            bindUser: [],
            deptId: ""
        };
    }

    componentDidMount() {
        this.pageChange();
        this.getLeftMenuDatas();
        Action.getRoleData({}, (res) => {
            let roleList = [];
            let roleNewData = [];
            if (res && res.data) {
                roleList = res.data;
                roleList.forEach(item => {
                    roleNewData.push({title: item.roleName, value: item.id, key: item.id})
                })
                this.setState({
                    roleNewData
                })
            }
        })
    }

// 获取列表数据
    pageChange() {
        let params = {
            start: this.state.start,
            size: this.state.size,
        };
        if (this.state.nodeKey.length > 0) {
            params.deptId = this.state.nodeKey;
        }
        if (this.state.searchValue) {
            params.queryStr = this.state.searchValue;
            params.deptId = 0
        }
        if (this.state.deptKey) {
            params.deptId = this.state.deptId;
        }
        if (this.state.roleKey) {
            params.role = this.state.roleKey;
        }
        Action.getUserManagementListData(params, (res) => {
            let dataList = [];
            let listTotal = 0;
            if (res && res.data) {
                dataList = res.data;
                listTotal = res.count;
            }
            this.setState({
                dataList: dataList,
                listTotal: listTotal,
            });
        });
    }

    //获得左侧菜单数据
    getLeftMenuDatas() {
        let params = {};
        Action.getLeftMenuData(params, (res) => {
            if (res && res.data) {
                this.state.deptTreeData = res.data;
                //重组数据  父子关系
                res.data.forEach((items) => {
                    items.checked = false;
                    if (items.id !== 0) {   // 除去顶级之外的进行循环
                        res.data.forEach((child) => {     // 双重循环
                            if (items.fid === child.id) {   // 外层的fid 等于 里层的id的话，则外层的数据为子集
                                let childArray = child.children;    // 判断是否有children，如果没有则添加一个空数组childArray
                                if (!childArray) {
                                    childArray = [];
                                }
                                childArray.push(items);    // 将数据push到childArray数组里面
                                child.children = childArray;   // 将组装好的数组赋值给children
                            }
                        });
                    }
                })
                let newData = res.data;
                let useData = [];
                let deptNewData = [];
                newData.forEach(current => {
                    if (!current.fid) {    //  !0===true
                        useData.push(current);
                    }
                    deptNewData.push({title: current.name, value: current.name, key: current.id})
                })
                let menuList = [
                    {
                        name: "所有部门",
                        key: "0",
                        id: 0,
                        sons: useData,
                    },
                ];
                this.setState({
                    currentLeftMenuList: menuList,
                    deptNewData
                })
            }
        })
    }

    // 渲染节点
    renderTreeNodes = data => {
        return (
            data.map(item => {
                if (item.sons) {
                    return (
                        <TreeNode checkable={false} key={item.id} title={<span>{item.name}</span>}>
                            {this.renderTreeNodes(item.sons)}
                        </TreeNode>
                    )
                }
                if (item.children) {
                    return (
                        <TreeNode key={item.id} title={<span>{item.name}</span>}>
                            {this.renderTreeNodes(item.children)}
                        </TreeNode>
                    )
                }
                return <TreeNode key={item.id} title={<span>{item.name}</span>}/>;
            })
        );
    }

    render() {
        let newSecondSelectColor =
            this.props.config && this.props.config.getValueByKey
                ? this.props.config.getValueByKey("newSecondSelectColor", "#1E9FFF")
                : "#1E9FFF";
        let height = document.body.clientHeight - HEADER_HEIGHT; //上部分70//
        return (
            <div>
                <div>
                    <div
                        style={{
                            backgroundColor: "#fff",
                        }}
                    >
                        <Row>
                            <Col span={5}>
                                <div
                                    style={{
                                        width: "400px",
                                        height: "810px",
                                        padding: "20px 0px 20px 60px",
                                        // overflow:"auto"
                                    }}
                                >
                                    {/* 左侧菜单 */}
                                    <Scrollbars>
                                        {this.state.currentLeftMenuList.length > 0 ? (
                                            <Tree
                                                defaultExpandAll
                                                onSelect={this.onSelect}
                                                selectedKeys={this.state.nodeKey}
                                            >
                                                {this.renderTreeNodes(this.state.currentLeftMenuList)}
                                            </Tree>
                                        ) : null}
                                    </Scrollbars>
                                </div>
                            </Col>
                            <Col
                                span={19}
                                style={{
                                    paddingLeft: "20px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "100%",
                                        display: "flex",
                                        justifyContent: "space-between",
                                        marginTop: "27px",
                                        paddingBottom: "10px",
                                        borderBottom: "1px solid #f6f6f6",
                                    }}
                                >
                                    <div style={{display: "flex"}}>
                                        <div>
                                            <Button type="primary" onClick={this.addUser}>
                                                添加用户
                                            </Button>
                                        </div>
                                        {/*添加用户*/}
                                        <div>
                                            <AddUser
                                                title={this.state.userStatus === 1 ? "用户信息" : "添加用户"}
                                                visible={this.state.userVisible}
                                                currentLeftMenuList={this.state.currentLeftMenuList}
                                                renderTreeNodes={() => this.renderTreeNodes(this.state.currentLeftMenuList)}
                                                addUserProps={this.state.addUserProps}
                                                closeModel={() => this.closeModel()}
                                                id={this.state.id}
                                                pageChange={() => this.pageChange()}
                                                ref={(c) => this.addUsers = c}
                                                deptTreeData={this.state.deptTreeData}
                                                allMedia={this.state.allMedia}
                                            />
                                        </div>

                                        <div style={{marginLeft: "30px"}}>
                                            <Button type="danger" onClick={this.delUser}>
                                                删除用户
                                            </Button>
                                        </div>
                                    </div>
                                    <div style={{display: "flex", alignItems: "center"}}>
                                        <div style={{marginRight: "20px"}}>
                                            <TreeSelect
                                                placeholder="请选择部门"
                                                style={{width: "200px"}}
                                                dropdownStyle={{height: "200px"}}
                                                dropdownMatchSelectWidth={true}
                                                value={this.state.deptKey ? this.state.deptKey : undefined}
                                                treeData={this.state.deptNewData}
                                                onChange={(value, label, extra) => {
                                                    this.state.deptKey = value;
                                                    this.state.deptId = extra.triggerNode.props.eventKey;
                                                    this.state.size = 10;
                                                    this.state.start = 1;
                                                    this.setState({})
                                                    this.pageChange();
                                                }}
                                            />
                                        </div>
                                        <div style={{marginRight: "20px"}}>
                                            <TreeSelect
                                                placeholder="请选择角色"
                                                style={{width: "200px"}}
                                                dropdownStyle={{height: "200px"}}
                                                value={this.state.roleKey ? this.state.roleKey : undefined}
                                                treeData={this.state.roleNewData}
                                                onChange={(value, label, extra) => {
                                                    this.state.roleKey = value;
                                                    this.state.size = 10;
                                                    this.state.start = 1;
                                                    this.setState({})
                                                    this.pageChange();
                                                }}
                                            />
                                        </div>
                                        <div style={{marginRight: "10px"}}>
                                            <Search
                                                placeholder="请输入搜索内容"
                                                onSearch={(value) => this.onSearch(value)}
                                                value={this.state.searchValue}
                                                onChange={(e) => {
                                                    this.setState({
                                                        searchValue: e.target.value,
                                                    });
                                                }}
                                                style={{width: 200}}
                                            />
                                        </div>
                                        <div style={{margin: "0px 10px"}}>
                                            <Button type="primary" onClick={this.userManageReset} style={{
                                                backgroundColor: newSecondSelectColor,
                                                border: newSecondSelectColor,
                                                color: "#fff"
                                            }}>重置</Button>
                                        </div>
                                    </div>
                                </div>
                                {/* 处理滚动条的方法以及自适应 */}
                                <div style={{height: height - 125, background: "white", width: "100%"}}>
                                    <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
                                        <UserManagementSysList
                                            ref={(c) => this.userListItem = c}
                                            pageChange={() => this.pageChange()}
                                            newSecondSelectColor={newSecondSelectColor}
                                            dataList={this.state.dataList}
                                            clickName={(item) => this.clickName(item)}
                                        />
                                    </Scrollbars>
                                </div>
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "flex-end",
                                        margin: "10px 10px 10px 0px"
                                    }}
                                >
                                    <Pagination
                                        showQuickJumper
                                        current={this.state.start}
                                        pageSize={this.state.size}
                                        total={this.state.listTotal}
                                        showTotal={(total) => `共 ${total} 条`}
                                        showSizeChanger
                                        onChange={(page, pageSize) =>
                                            this.onChange(page, pageSize)
                                        }
                                        onShowSizeChange={(page, pageSize) => {
                                            this.onChange(page, pageSize);
                                        }}
                                    />
                                </div>
                            </Col>
                            <Modal
                                title="信息"
                                visible={this.state.delVisible}
                                onOk={this.delOk}
                                onCancel={this.delCancel}
                                width="300px"
                                centered
                            >
                                确定要删除吗？
                            </Modal>
                        </Row>
                    </div>
                </div>
            </div>
        );
    }

    //用户信息预览
    clickName(item) {
        console.log(item);
        let userStatus = 1;
        this.state.id = item.id;
        this.setState({
            userStatus,
            userVisible: true,
            addUserProps: {
                accountValue: item.account,
                nameValue: item.name,
                officePhoneValue: item.tel,
                sexValue: item.sex,
                phoneValue: item.phone,
                allDept: item.allDept,
                checkedKeys: item.deptIds,
                propertyValue: item.props,
                typeKey: item.roleCodes,
                allRole: item.allRole,
                mediaRoleCodes: item.mediaRoleCodes,
                mediaCodes: item.mediaCodes,
                roleCodes: item.roleCodes,
                allMedia: item.allMedia,
            },
        })
        this.addUsers.accountDisabled();
        this.getByAccountAndOwners(item);
    }

    //绑定的用户数据
    getByAccountAndOwners(item) {
        item.allMedia.forEach((i, index) => {
            let params = {
                account: item.account,
                owner: i.owner
            }
            Action.getByAccountAndOwner(params, (res) => {
                let selectItem = {};
                if (res) {
                    selectItem.wbaccount = res.vsbuser;
                    i.select = selectItem;
                }
                if (index === item.allMedia.length - 1) {
                    this.setState({
                        allMedia: item.allMedia,
                    })
                }

            })
        })
    }

    //关闭Modal
    closeModel() {
        this.setState({
            userVisible: false,
            id: ""
        });
    }

    //删除用户
    delOk = () => {
        Action.getDeleteData({useraccounts: this.userListItem.state.currentName}, (res) => {
            if (res) {
                message.success("删除成功");
                this.pageChange();
            } else {
                message.error("请先解除关联关系后再删除用户");
            }
        })
        this.setState({
            delVisible: false
        })
    }

    delCancel = () => {
        this.setState({
            delVisible: false
        })
    }

    delUser = () => {
        if (this.userListItem.state.selectedStatus) {
            this.setState({
                delVisible: true
            })
        } else {
            message.info("请选择删除的账号");
        }

    }
    //添加用户
    addUser = () => {
        let userStatus = 0;
        this.setState({
            userStatus,
            userVisible: true,
        })
        this.addUsers.revert();
        this.addUsers.accountNotDisabled();
    }
    //重置
    userManageReset = () => {
        this.setState({
            start: 1,
            size: 10
        })
        this.state.searchValue = "";
        this.state.roleKey = "";
        this.state.deptKey = "";
        this.state.nodeKey = "";
        this.pageChange();
    }

    // 页面改变时回调
    onChange(page, pageSize) {
        this.state.start = page;
        this.state.size = pageSize;
        this.pageChange();
    }

    //搜索
    onSearch(value) {
        this.state.searchValue = value;
        this.state.start = 1;
        this.state.size = 10;
        this.pageChange();
    }

    //   点击树节点
    onSelect = (selectedKeys) => {
        this.state.nodeKey = selectedKeys;
        this.state.pageNo = 1;
        this.state.limit = 10;
        this.setState({});
        this.pageChange();
    };
}

function mapStateToProps(state) {
    return {
        currentUser: state.systemReducer.currentUser,
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(userManagementSys);
